import { HasChildren } from "@types";
import useDashboard from "hooks/useDashBoard";
import useQRサービス券駐車場グループ管理Tabs from "layouts/dashbord/tab/QRServiceTicketParkingProupManagementTabs";
import { PageID } from "pages";
import { createContext, useEffect } from "react";

// Context is now empty as data fetching is moved to individual pages
export const QRサービス券駐車場グループ管理Context = createContext({});

type Props = HasChildren;
function QRサービス券駐車場グループ管理ContextProvider({ children }: Props) {
  const { setHeaderTitle } = useDashboard(PageID.QRサービス券駐車場グループ管理);

  useEffect(() => {
    setHeaderTitle("QRサービス券駐車場グループ管理");
  }, []);

  return (
    <QRサービス券駐車場グループ管理Context.Provider value={{}}>
      <TabInit />
      {children}
    </QRサービス券駐車場グループ管理Context.Provider>
  );
}

function TabInit() {
  const { setTabs, tabId } = useDashboard();
  const { element } = useQRサービス券駐車場グループ管理Tabs();

  useEffect(() => {
    setTabs(element);
  }, [tabId]);

  return null;
}

export default QRサービス券駐車場グループ管理ContextProvider;
